import dynamic from 'next/dynamic';

export * from './basket-back';
export * from './basket-gift-items';
export * from './basket-invalid-lines';
export * from './basket-item';
export * from './basket-mobile-menu';
export * from './basket-summary';
export * from './basket-usp';

export const BasketPage = dynamic(() => import('./basket-page'), { ssr: false });
